/* 2009-2018 Copyright Ridecell Inc. All rights reserved. */
import sweetalert2 from './sweetalert2/sweetalert2'

export default {
  sweetalert2,
}
